var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-links scrolling-tabs separator"},_vm._l((_vm.tabs),function(tab,i){return _c('li',{key:i,class:{
      active: tab.isActive,
    }},[_c('a',{class:("js-" + _vm.scope + "-tab-" + (tab.scope)),attrs:{"role":"button"},on:{"click":function($event){_vm.onTabClick(tab)}}},[_vm._v("\n      "+_vm._s(tab.name)+"\n\n      "),(_vm.shouldRenderBadge(tab.count))?_c('span',{staticClass:"badge"},[_vm._v("\n        "+_vm._s(tab.count)+"\n      ")]):_vm._e()])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5f58ba","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/navigation_tabs.vue
// module id = null
// module chunks = 